import { Navigate, Route, Routes } from 'react-router-dom';
import UserList from './components/UserList';
import { UserForm } from './components/UserForm';
import { UserPlatforms } from './components/UserPlatforms';
import { UserPlatformLogsList } from './components/UserPlatformLogsList';
import { UserDeviceList } from './components/UserDeviceList';
import { UserAdvancedEdit } from './components/UserAdvancedEdit';
import { InfluencerList } from './components/influencers/InfluencerList';
import { hasAccessRight } from '../../utils/Functions';
import { AdminAclEnum } from '../../enum/AdminAclEnum';
import { InfluencerWithFeeList } from './components/influencers/InfluencerWithFeeList';

export function UserRoutes() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.INFLUENCERS) && <Route path="influencers" element={<InfluencerList />} />}
            {hasAccessRight(AdminAclEnum.INFLUENCER_FEE_OVERVIEW) && (
                <Route path="influencers/fee" element={<InfluencerWithFeeList />} />
            )}
            <Route path="devices/:id?" element={<UserDeviceList />} />
            {hasAccessRight(AdminAclEnum.USER_PLATFORM_LOGS) && (
                <Route path="platform/logs" element={<UserPlatformLogsList />} />
            )}
            {hasAccessRight(AdminAclEnum.USERS) && (
                <>
                    <Route index element={<UserList />} />
                    <Route path="edit/:id/:isUserList?" element={<UserForm />} />
                    {hasAccessRight(AdminAclEnum.USER_ADVANCED_EDIT) && (
                        <Route path="advanced-edit/:id" element={<UserAdvancedEdit />} />
                    )}
                    <Route path="platforms" element={<UserPlatforms />} />
                </>
            )}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}
